import { render, staticRenderFns } from "./ChartDoughnut.vue?vue&type=template&id=488f87d5&scoped=true"
import script from "./ChartDoughnut.vue?vue&type=script&lang=js"
export * from "./ChartDoughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f87d5",
  null
  
)

export default component.exports